<app-page-spinner [loaderText]="loaderText" [loaderIcon]="loaderIcon" [showLoaderMessage]="showLoaderMessage"> </app-page-spinner>
<app-universal-nav *ngIf="showNavigation"></app-universal-nav>
<app-prescriptions-header *ngIf="showNavigation"></app-prescriptions-header>
<app-prescription-container></app-prescription-container>

<main>
  <router-outlet />
</main>

<app-footer *ngIf="showFooter && showNavigation"></app-footer>
